module.exports = __webpack_public_path__ + "static/media/N10.95d76c8f.jpg";